import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconStarProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconStar: React.FC<IconStarProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Star',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.638-2.44a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconBase>
);

export default IconStar;
